import * as React from "react";
const SvgBookmarkUnchecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 12, y: 12, width: 16, height: 16, rx: 1, stroke: "#21262D", strokeWidth: 2 }));
export default SvgBookmarkUnchecked;
